/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_TaskInputs */

const cs_enum_entity_task = /** @type {(inputs: Enum_Entity_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol`)
};

const en_enum_entity_task = /** @type {(inputs: Enum_Entity_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Enum_Entity_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_task = /** @type {((inputs?: Enum_Entity_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_task(inputs)
	return cs_enum_entity_task(inputs)
});